import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const Container = styled.div`
  max-width: 600px;
  padding: ${theme.spacing.large};
`;

export const Title = styled.h3`
  margin: 0;
  padding: 0;
  padding-bottom: ${theme.spacing.large};
`;

export const ActionButtons = styled.div`
  text-align: right;
  padding-top: ${theme.spacing.xxLarge};

  button {
    margin-left: ${theme.spacing.large};
  }
`;

export const AudioRecorderContainer = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: ${theme.spacing.large};

  button {
    margin-right: ${theme.spacing.medium};
    background: ${theme.color.error};

    &:hover {
      background: ${theme.color.redDark};
    }
  }
`;

export const AudioPlayerContainer = styled.div`
  display: block;
  padding-bottom: ${theme.spacing.large};
`;
